export default "/images/availability_sm.jpg?078ebc2e8bdcea114e61dbec66a3bbe6";